import React, { useEffect, useMemo, useState } from "react";
import EditClients from "../EditClients";
import AddEditContact from "../AddEditContact";
import AddEditComplianceDocs from "../AddEditComplianceDocs";
import ClientCarePlans from "../ClientCarePlans";
import ClientJournalAsApp from "../ClientJournalAsApp";
import { useParams, useLocation } from "react-router-dom";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import { getAccessList } from "../../../utils/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import NoAccessMsg from "../../../components/NoAccessMsg";
// import { createAccessEvent } from "../../../redux-toolkit/reducer/eventLogsReducer";
import AboutMe from "../AboutMe";
import AdminSection from "../AdminSection";
import { fetchAdminClients } from "../../../redux-toolkit/reducer/admin_clients_reducer";
import ActivityTable from "../activity_notes/ActivityTable";
import CarePlan from "../care_plan/CarePlan";
import PublishDataTable from "../PublishDataTable";
import { useHistory } from "react-router-dom";

export default function ClientRoutes({ downloadingPages }) {
  const dispatch = useDispatch();
  const { adminClients } = useSelector((state) => state.adminClientReducer);
  const { accessRoles } = useSelector((state) => state.caresiteDataReducer);

  const moduleAccess = useMemo(() => {
    const findCurrentModule = accessRoles?.find(
      (item) => item.moduleName === "Clients"
    );
    const accesssList = getAccessList(findCurrentModule?.children);
    return accesssList;
  }, [accessRoles]);

  const { topicId } = useParams();
  // let params = useParams();
  const history = useHistory();
  const location = useLocation();
  const clientId = location.state?.clientId;

  // useEffect(() => {
  //   // create access event log
  //   const logData = {
  //     documentType: `client ${topicId}`,
  //     description: `Client ${topicId} page visited`,
  //     documentId: clientId,
  //   };
  //   dispatch(createAccessEvent(logData));
  // }, [topicId]);

  useEffect(() => {
    const clientCareHomeId = location.state?.careHomeId;
    if (currentCareSiteId !== clientCareHomeId) {
      history.push(`/clients`);
    }
    getClientbyId();
  }, []);

  const getClientbyId = () => {
    const queryString = `?clientId=${clientId}&careHomeId=${currentCareSiteId}`;
    dispatch(fetchAdminClients(queryString));
  };

  return (
    <>
      {(topicId === "profile" || downloadingPages) && (
        <>
          {moduleAccess?.Profile === "full" ||
          moduleAccess?.Profile === "view" ? (
            <EditClients
              clientAllData={adminClients}
              clientId={clientId}
              getClientbyId={getClientbyId}
              Profileaccess={moduleAccess?.Profile}
            />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {(topicId === "about-me" || downloadingPages) && (
        <>
          {moduleAccess?.Profile === "full" ||
          moduleAccess?.Profile === "view" ? (
            <AboutMe
              clientAllData={adminClients}
              clientId={clientId}
              getClientbyId={getClientbyId}
              Profileaccess={moduleAccess?.Profile}
            />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {(topicId === "admin-details" || downloadingPages) && (
        <>
          {moduleAccess?.Profile === "full" ||
          moduleAccess?.Profile === "view" ? (
            <AdminSection
              clientAllData={adminClients}
              clientId={clientId}
              getClientbyId={getClientbyId}
              Profileaccess={moduleAccess?.Profile}
            />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {topicId === "contacts" && (
        <>
          {moduleAccess?.Contacts === "full" ||
          moduleAccess?.Contacts === "view" ? (
            <AddEditContact
              clientAllData={adminClients}
              clientId={clientId}
              getClientbyId={getClientbyId}
              Contactaccess={moduleAccess?.Contacts}
            />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {topicId === "docs" && (
        <>
          {moduleAccess?.["Compliance Docs"] === "full" ||
          moduleAccess?.["Compliance Docs"] === "view" ? (
            <AddEditComplianceDocs
              clientAllData={adminClients}
              clientId={clientId}
              ComplianceDocsaccess={moduleAccess?.["Compliance Docs"]}
            />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {/* {topicId === "care-plan-old" && (
        <>
          {moduleAccess?.["Care Plan"] === "full" ||
          moduleAccess?.["Care Plan"] === "view" ? (
            <ClientCarePlans
              clientAllData={adminClients}
              clientId={clientId}
              CareplanAccess={moduleAccess?.["Care Plan"]}
            />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )} */}
      {topicId === "care-plan" && (
        <>
          {moduleAccess?.["Care Plan"] === "full" ||
          moduleAccess?.["Care Plan"] === "view" ? (
            <CarePlan
              clientAllData={adminClients}
              clientId={clientId}
              CareplanAccess={moduleAccess?.["Care Plan"]}
            />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {topicId === "journal" && (
        <>
          {moduleAccess?.Journal === "full" ||
          moduleAccess?.Journal === "view" ? (
            <ClientJournalAsApp
              clientId={clientId}
              JournalAccess={moduleAccess?.Journal}
            />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {topicId === "activity" && (
        <>
          {moduleAccess?.Journal === "full" ||
          moduleAccess?.Journal === "view" ? (
            <ActivityTable clientId={clientId} />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
      {topicId === "publish-data" && (
        <>
          {moduleAccess?.Journal === "full" ||
          moduleAccess?.Journal === "view" ? (
            <PublishDataTable clientId={clientId} />
          ) : (
            <NoAccessMsg />
          )}
        </>
      )}
    </>
  );
}
